import { HealthcareFacility, HealthcareFacilityQuery } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { healthcareOrganizationTranslationKeys } from '../../../../translations';

type HealthcareFacilityUpdateFormRenderProps = {
   healthcareFacility: HealthcareFacility;
};

type HealthcareFacilityUpdateFormLoaderProps = {
   readonly healthcareFacilityId: number;
   readonly children: (renderProps: HealthcareFacilityUpdateFormRenderProps) => JSX.Element;
};

export const HealthcareFacilityUpdateFormLoader = (props: HealthcareFacilityUpdateFormLoaderProps): JSX.Element => {
   const {
      data: healthcareFacility,
      loading: healthcareFacilityLoading,
      error: healthcareFacilityError,
   } = useCqrsGet<HealthcareFacility>(() => {
      const query = new HealthcareFacilityQuery();
      query.id = Slot.of(props.healthcareFacilityId);
      return query;
   });

   if (healthcareFacilityLoading) {
      return <LoaderSpinner />;
   }

   if (healthcareFacilityError) {
      return (
         <Message
            testId={'failedToFetchHealthcareFacility'}
            label={healthcareOrganizationTranslationKeys.failedToFetchHealthcareFacility}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      healthcareFacility: healthcareFacility,
   });
};
